<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex sm12>
                    <h3>مدیریت طرح‌ها</h3>
                </v-flex>
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                    flat
                                    solo
                                    prepend-icon="search"
                                    placeholder="جستجو..."
                                    v-model="search"
                                    hide-details
                                    class="hidden-sm-and-down"
                            ></v-text-field>
                            <v-btn icon>
                                <v-icon>filter_list</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="complex.headers"
                                    :search="search"
                                    :items="complex.items"
                                    :rows-per-page-items="[25,50,100,500,{text:'همه','value':-1}]"
                                    class="elevation-1"
                                    item-key="Name"
                                    select-all
                                    v-model="complex.selected"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-center">
                                        <v-checkbox
                                                primary
                                                hide-details
                                                v-model="props.selected"
                                        ></v-checkbox>
                                    </td>
                                    <td class="text-xs-center">{{ props.item.art_id }}</td>
                                    <td class="text-xs-center">{{ props.item.title }}</td>
                                    <td class="text-xs-center"><v-img :src="`/reseller_privates/_thumb_artworks/`+props.item.base_image_thumb" height="70px"></v-img></td>
                                    <td class="text-xs-center">{{ getStores(props.item.store_id) }}</td>
                                    <td class="text-xs-center" style="direction: ltr">{{ toJalali(props.item.created_at)}}</td>
                                    <td class="text-xs-center">{{ statuses[props.item.finalized] }}</td>
                                    <td class="text-xs-center">{{ getCategories(props.item.category_id) }}</td>
                                    <td class="text-xs-center">
                                        <v-btn depressed outline icon fab dark color="primary"
                                               @click="$router.push(`/pages/artworks/edit/`+props.item.art_id)" small>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn depressed outline icon fab dark color="pink" @click="del(props.item.art_id)" small>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-snackbar
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    :top="snackbar.y === 'top'"
                    :bottom="snackbar.y === 'bottom'"
                    :right="snackbar.x === 'right'"
                    :left="snackbar.x === 'left'"
                    :multi-line="snackbar.mode === 'multi-line'"
                    :vertical="snackbar.mode === 'vertical'"
                    v-model="snackbar.snackbar"
            >
                {{ snackbar.text }}
                <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-container>
    </div>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';

export default {
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      search: '',
      statuses: [
        'ناتمام',
        'فعال',
        'غیرفعال'
      ],
      stores: [],
      categories: [],
      complex: {
        selected: [],
        headers: [
          {
            text: ' شناسه',
            value: 'art_id',
            align: 'center'
          },
          {
            text: 'عنوان طرح',
            value: 'title',
            align: 'center'
          },
          {
            text: 'تصویر',
            value: 'base_image',
            align: 'center'
          },
          {
            text: 'فروشگاه',
            value: 'store_id',
            align: 'center'
          },
          {
            text: 'تاریخ ساخت',
            value: 'created_at',
            align: 'center'
          },
          {
            text: 'وضعیت',
            value: 'finalized',
            align: 'center'
          },
          {
            text: 'دسته بندی',
            value: 'category_id',
            align: 'center'
          },
          {
            text: 'مدیریت',
            value: '',
            align: 'center'
          },
        ],
        items: []
      }
    };
  },
  created: function () {
    this.arts();
    this.axios.get('/reseller/stores/')
      .then(response => {
        this.stores = response.data.Data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
    this.axios.get('/reseller/artwork_categories/')
      .then(response => {
        this.categories = response.data.Data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  },
  methods: {
    del: function (id) {
      this.DeleteEntityPromise('artworks', id).then(() => {
        this.arts();
      });
    },
    arts: function () {
      this.axios.get('/reseller/artworks/')
        .then(response => {
          this.complex.items = response.data.Data;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    getStores: function (id) {
      let i = this.stores.findIndex(s => s.shop_id === id);
      if (i < 0) {
        return 'نامشخص';
      }
      return this.stores[i].shop_name;
    },
    getCategories: function (id) {
      let i = this.categories.findIndex(s => s.ac_id === id);
      if (i < 0) {
        return 'نامشخص';
      }
      return this.categories[i].name;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/art/modify.vue